export enum CRMTriggerType {
  TEMPORAL = 'TEMPORAL'
}

export class CRMTrigger {
  id: number;
  type: CRMTriggerType;
  entity: string;
  entityId: string;
  property: string;
  value: string;
}

export enum CRMResolutionAction {
  SET = 'SET'
}

export enum CRMResolutionEntity {
  CRM_ITEM = 'CRM_ITEM',
  CRM_ITEM_USER = 'CRM_ITEM_USER'
}

export class CRMResolution {
  id: number;
  action: CRMResolutionAction;
  entity: CRMResolutionEntity;
  entityId: string;
  property: string;
  value: string;
}

export class CRMAlarm {
  provisional: boolean;
  trigger: CRMTrigger;
  resolutionList: Array<CRMResolution>;
}
